/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useCallback, useMemo, useState } from 'react'

// @context
import { useUI } from '../../../app/context/ui';

// @services
import TicketService from '../../../services/newApi/TicketServiceNewApi';

// @helpers
import AppHelper from '../../../helpers/AppHelper';

const useTickets = () => {
  const { blockUI, snackbarUI } = useUI();
  const ticketService = useMemo(() => new TicketService(), []);
  
  const [rowsState, setRowsState] = useState({
    pageSize: 10,
    rows: [],
    rowCount: 0,
    currentPage: 1,
    page: 0,
  });

  const [filterTicket, setFilterTicket] = useState({
    status: null,
    updatedAt: null,
    createdAt: null
  });

  const [sortBy, setSortBy] = useState({
    sort: '',
    direction: ''
  });
  
  const handleMapResponse = async (params) => {
    blockUI.current?.open(true);
    const pagination = {
      page: params?.pagination?.page ?? 1,
      size: params?.pagination?.size ?? rowsState.pageSize,
    };
    const sort = {
      sortBy: params?.orderBy?.sort,
      sortDescending: params?.orderBy?.direction === 'desc' ? true : false,
    };
    const paramValue = {
      pagination,
      filters: params?.filters ?? {},
      sort
    }
    getListTickets(paramValue);
  }

  const getListTickets = async (paramValue) => {
    try {
      const response = await ticketService.getTickets(paramValue);
      updateTableState(response?.data);
    } catch (error) {
      handleError(error);
    }
  }

  const updateTableState = useCallback((data) => {
    setRowsState((prev) => ({
      ...prev,
      pageSize: data?.pagination?.page_size || 10,
      rows: data?.data || [],
      rowCount: data?.pagination?.total_records || 0,
      currentPage: data?.pagination?.page_number,
      page: data?.pagination?.page_number - 1,
    }));
    blockUI.current?.open(false);
  }, []);

  const handleError = useCallback((error) => {
      AppHelper.checkError(error, snackbarUI);
      blockUI.current?.open(false);
    },
    [snackbarUI, blockUI]
  );
  
  return {
    handleMapResponse,
    rowsState,
    setRowsState,
    filterTicket,
    setFilterTicket,
    sortBy,
    setSortBy
  }
}

export default useTickets